import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms'
import { SaveForm } from '@tokeet-frontend/tv3-platform'
import { AutomationHandler, AutomationHelpers, AutomationViewGroup } from '@tokeet-frontend/automations'

export interface AutomationDocumentFormData {
  handler: AutomationHandler
  template: string
  guest: boolean
  users?: string[]
}

@Component({
  selector: 'app-automation-document-form-dialog',
  templateUrl: './automation-document-form-dialog.component.html',
  styleUrls: ['./automation-document-form-dialog.component.scss'],
  host: { class: 'modal-content' },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AutomationDocumentFormDialogComponent implements OnInit {
  eventCtrl = new UntypedFormControl()
  form = this.fb.group({
    handler: ['', [Validators.required]],
    template: ['', [Validators.required]],
    guest: [false],
    users: this.fb.array([]),
  })

  get automation() {
    return this.data.automation
  }

  constructor(
    public dialogRef: MatDialogRef<AutomationDocumentFormDialogComponent>,
    private fb: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: { automation?: AutomationViewGroup }
  ) {
    if (this.automation) {
      this.form.patchValue({
        ...this.automation,
        guest: AutomationHelpers.sendToGuest(this.automation.items),
      })
    }
  }

  ngOnInit(): void {}

  close() {
    this.dialogRef.close()
  }

  @SaveForm()
  onSave(form: UntypedFormGroup) {
    this.dialogRef.close(form.getRawValue())
  }
}
